// 菜单
import menu from './menu.js'
// 模块
import module from './module.js'

let allUrlList = Object.assign(
    {},menu,module
);
export default allUrlList 


// WEBPACK FOOTER //
// ./src/api/url/url.js